export default {
  items: state => state.items,
  speed: state => state.speed,
  active: state => state.active,
  previous: state => state.previous,
  initialized: state => state.initialized,
  animating: state => state.animating,
  pause: state => state.pause,
  count: state => state.items.length,
  scrolltopanel: state => state.scrolltopanel,
  isfirstactive: state => state.isfirstactive,
  islastactive: state => state.islastactive,
  scrolltocomplete: (state) => state.scrolltocomplete,
  paneltheme: (state) => {
    return (state.items[state.active]) ? state.items[state.active].theme : null
  },
  navtheme: (state) => {
    return (state.items[state.active]) ? state.items[state.active].navtheme : null
  },
  logotheme: (state) => {
    return (state.items[state.active]) ? state.items[state.active].logotheme : null
  },
  fetch: (state) => (id) => {
    return state.items.find(item => item.id === id)
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/panels/getters.js